import React, { useEffect, useState, useContext } from "react";

import { useRouter } from "next/router";

import EventKit from "../../data/EventKit";
import { EventContext } from "../../contexts/EventContext";
import NavigationBrowserView from "./Views/Navigation.BrowserView";
import NavigationMobileView from "./Views/Navigation.MobileView";

export default function Navigation() {
  const router = useRouter();
  const { event } = router.query;

  const [eventData, setEventData] = useState(null);
  const [isBackButtonDisabled, setIsBackButtonDisabled] = useState(false);
  const { globalEventData, setGlobalEventData } = useContext(EventContext);
  const eventKit = new EventKit();

  function handleOnBackClick() {

    if (!isBackButtonDisabled) {
      router.back();
    }
  }

  function getHomepageHref() {
    if (eventData && eventData.hasHomepage) {
      return "/[event]/[page]";
    } else {
      return "/[event]";
    }
  }

  useEffect(() => {
    if (globalEventData) {
      setEventData(globalEventData);
    } else {
      eventKit.getEventDetail(event).then((data) => {
        setEventData(data);
        setGlobalEventData(data);
      });
    }
  }, []);

  useEffect(() => {
    const isHome = router.pathname == "/[event]";
    setIsBackButtonDisabled(isHome);
  }, [router.pathname]);

  return (
    <>
      {event && (
        <>
          <NavigationBrowserView
            handleOnBackClick={handleOnBackClick}
            getHomepageHref={getHomepageHref}
            eventData={eventData}
          />
          <NavigationMobileView
            handleOnBackClick={handleOnBackClick}
            getHomepageHref={getHomepageHref}
            eventData={eventData}
            isBackButtonDisabled={isBackButtonDisabled}
          />
        </>
      )}
    </>
  );
}
